import { render } from "./payment-request-summary.vue?vue&type=template&id=c31559f2&scoped=true"
import script from "./payment-request-summary.vue?vue&type=script&lang=js"
export * from "./payment-request-summary.vue?vue&type=script&lang=js"

import "./payment-request-summary.vue?vue&type=style&index=0&id=c31559f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31559f2"]])

export default __exports__